module.exports = __webpack_public_path__ + "assets/default-7a2de2.svg";